export const fileTypes =
  "video/mp4,image/jpg,image/jpeg,image/png,application/pdf,image/svg";
export const PDFFile = "application/pdf";
export const imageTypes = "image/jpg,image/jpeg,image/png,image/bmp";
export const maxFileSize = 5 * 1024 * 1000; // 5MB
